/**
 * This creates a range of values between upper and lower they are all equal distance apart
 * @param upper the highest number
 * @param lower the lowest number
 * @param steps how many steps do you want to create?
 * @returns an array of numbers that are equally spaced between the upper and lower values
 */
export function generateRange({
  upper,
  lower,
  steps,
}: {
  upper: number;
  lower: number;
  steps: number;
}) {
  if (steps <= 1) {
    return [lower, upper];
  }

  const difference = upper - lower;
  const increment = difference / (steps - 1);
  return [
    lower,
    ...Array(steps - 2)
      .fill('')
      .map((_, index) => lower + increment * (index + 1)),
    upper,
  ];
}
